import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { AssetDto, GalleryAccessLevel, GalleryDto, GalleryPublicAccessLevel } from '@picflow/types';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { AccessLevelService } from 'src/app/services/access-level.service';
import { DialogService, OnGetData } from 'src/app/services/dialog.service';
import { ShareService } from 'src/app/services/share.service';
import { TenantService } from 'src/app/services/tenant.service';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';
import { ShareAssetLinkComponent } from '../../components/share-asset-link/share-asset-link.component';
import { ShareGalleryDialogComponent } from '../share-gallery-dialog/share-gallery-dialog.component';
import { WorkspaceDialogComponent } from '../workspace-dialog/workspace-dialog.component';

@Component({
  selector: 'app-share-asset-dialog',
  templateUrl: './share-asset-dialog.component.html',
  styleUrls: ['./share-asset-dialog.component.scss'],
  standalone: true,
  imports: [NgIf, ShareAssetLinkComponent, AssetUrlPipe, AsyncPipe],
})
export class ShareAssetDialogComponent implements OnGetData {
  dialogName = 'share-asset';
  gallery: GalleryDto;
  asset: AssetDto;
  publicLink: string;
  close: Function;
  loading = true;
  accessLevel: GalleryAccessLevel;
  publicAccessLevel: GalleryPublicAccessLevel;
  canShare = navigator.share && ScreenSizes.screenSize() !== 'desktop';
  hideAll = false;

  dialogOptions(): DialogOptions {
    return { size: 560, hideClose: true, spacingX: 40, spacingY: 40 };
  }

  constructor(
    private dialog: DialogService,
    private shareService: ShareService,
    private accessLevelService: AccessLevelService,
    private tenantService: TenantService
  ) {}

  async onGetData(data: any, close: Function) {
    if (this.tenantService.shouldShowWorkspaceDialog(data.gallery)) {
      this.hideAll = true;
      return this.dialog.open(WorkspaceDialogComponent, {
        onDone: () => this.dialog.open(ShareGalleryDialogComponent, data),
        gallery: data.gallery,
      });
    }

    this.gallery = data.gallery;
    this.asset = data.asset;
    this.close = close;
    this.getLink();
    this.accessLevel = await this.accessLevelService.getAccessLevel(this.gallery);
  }

  private async getLink() {
    const link = await this.shareService.getShareLink(this.gallery, { assetId: this.asset?.id });
    this.publicLink = link.url;
  }
}
